<template>
  <div class="login">
    <!-- 头部 -->
    <Header></Header>
    <div class="container">
      <div class="w">
        <div class="login">
          <h1 class="title">欢迎回来</h1>
          <!-- 登陆账号密码框 -->
          <label for="u">
            <div class="uname">
              <span>
                <img src="../assets/icons/uname.png" />
                <div>
                  <input
                    type="text"
                    oninput="value=value.replace(/[^\d]/g,'')"
                    placeholder="请输入您的账号"
                    id="u"
                    v-model="loginInfo.account"
                  />
                </div>
              </span>
            </div>
          </label>
          <label for="p">
            <div class="password">
              <span>
                <img src="../assets/icons/pwd.png" />
                <div>
                  <input type="password" placeholder="请输入您的密码" id="p" v-model="loginInfo.password" />
                </div>
              </span>
            </div>
          </label>
          <div class="option clearfix">
            <div class="left">
              <label>
                <input type="checkbox" class="check" v-model="checkVal" />下次自动登录
              </label>
            </div>
            <a href="javascript:;" @click="gofindPassWord()">忘记密码?</a>
          </div>
          <!-- 登陆按钮 -->
          <button class="login-button" @click="login()">登陆</button>
          <button v-on:keyup.enter="login()"></button>
          <!-- 登录方式 -->
          <div class="login-me clearfix">
            <div class="btn-Group">
              <span>
                <img src="../assets/icons/QQ.png" alt="QQ登陆" title="QQ登陆" @click="w()" />
              </span>
              <span>
                <img
                  src="../assets/icons/WeChat.png"
                  alt="微信登陆"
                  title="微信登陆"
                  class="weChat"
                  @click="weChatLogin()"
                />
              </span>
            </div>
            <a href="javascript:;" @click="goRegister()">没有账号,去注册</a>
          </div>
        </div>
      </div>
      <el-dialog :visible.sync="dialogVisible" style="text-align:center" width="50%">
        <img :src="ewmurl" />
        <button class="sx" @click="weChatLogin()">点击刷新二维码</button>
      </el-dialog>
    </div>
    <!-- 尾部 -->
    <Fotter></Fotter>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from '../components/common/Header'
import Fotter from '../components/common/Fotter'

export default {
  name: 'login',
  data() {
    return {
      checkVal: false,
      dialogVisible: false,
      ewmurl: '',
      loginInfo: {
        account: '',
        password: ''
      },
      code: '',
      timer: '',
      logoUlr: ''
    }
  },
  components: {
    Header,
    Fotter
  },
  methods: {
    goRegister() {
      this.$router.push('/register')
    },
    gofindPassWord() {
      this.$router.push('/findPassWord')
    },
    async login() {
      if (!this.loginInfo.account.trim() || !this.loginInfo.password.trim()) {
        this.$message.error('请输入完整的账号或密码')
        return
      }
      let param = new URLSearchParams()
      param.append('account', this.loginInfo.account)
      param.append('password', this.loginInfo.password)
      const { data: res } = await this.$http.post('/api/user/login', param)
      if (res.code == 1) {
        this.$message.success('登陆成功！')
        let userobj = {
          id: res.data.userinfo.id,
          username: res.data.userinfo.username,
          mobile: res.data.userinfo.mobile,
          avatar: res.data.userinfo.avatar,
          expiretime: res.data.userinfo.expiretime,
          nickname: res.data.userinfo.nickname
        }
        window.localStorage.setItem('token', res.data.userinfo.token)
        window.localStorage.setItem('u', JSON.stringify(userobj))
        this.$router.push('/index')
      } else {
        this.$confirm('登陆失败！' + res.msg, '提示')
      }
    },
    // 微信登陆
    async weChatLogin() {
      const { data: res } = await this.$http({
        method: 'post',
        url: 'api/slogn/code'
      })
      if (res.code == 1) {
        this.code = res.data.code
        let param = new URLSearchParams()
        param.append('sign', res.data.code)
        const resl = await this.$http.get(
          'api/slogn/qrcode?sign=' + res.data.code
        )
        this.dialogVisible = true
        this.ewmurl = resl.config.url
        // 先清空定时器
        clearInterval(this.timer)
        this.timer = setInterval(async () => {
          const { data: reslu } = await this.$http({
            method: 'post',
            url: 'api/slogn/check',
            data: param
          })
          if (reslu.code == 1 && reslu.msg == '已绑定用户') {
            let userObj = {
              id: reslu.data.id,
              username: reslu.data.username,
              mobile: reslu.data.mobile,
              avatar: reslu.data.avatar
            }
            window.localStorage.setItem('token', reslu.data.token)
            window.localStorage.setItem('u', JSON.stringify(userObj))
            this.$message.success('微信登陆成功!')
            this.$router.push('/')
            clearInterval(this.timer)
          } else if (reslu.code == 1 && reslu.msg == '未绑定用户') {
            window.sessionStorage.setItem('f', 'true')
            window.sessionStorage.setItem('id', reslu.data.uid)
            this.$router.push('/register')
            clearInterval(this.timer)
          }
        }, 1000)
      } else {
        this.$confirm('微信登陆出错了', '提示')
      }
    },
    // 按回车键登陆
    created() {
      document.onkeydown = e => {
        var key = window.event.keyCode
        if (key == 13) {
          this.login()
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
.container {
  height: 600px;
  background: url('../assets/images/banner.png');
  .w .login {
    box-sizing: border-box;
    position: relative;
    top: 75px;
    right: 0;
    bottom: 75px;
    float: right;
    padding: 35px 22px 25px 22px;
    width: 383px;
    height: 450px;
    background-color: #fff;
    border-radius: 15px;
    .check {
      -webkit-appearance: none;
      appearance: none;
      outline: none;
      width: 20px;
      height: 20px;
      cursor: pointer;
      vertical-align: center;
      background: #fff;
      border: 1px solid #ccc;
      position: relative;
    }
    .check:checked::after {
      content: '\2713';
      display: block;
      position: absolute;
      top: 4px;
      left: 2px;
      right: 0;
      bottom: 0;
      width: 18px;
      height: 18px;
      line-height: 10px;
      color: #ffa525;
      font-size: 18px;
    }
    .title {
      font-family: 'Microsoft YaHei';
      margin-bottom: 30px;
      font-size: 24px;
      color: #333;
    }
    .uname,
    .password {
      box-sizing: border-box;
      width: 100%;
      height: 48px;
      margin-bottom: 20px;
      background-color: #eef2f5;
      border-radius: 10px;
      padding: 12px 20px;
      span {
        width: 19px;
        height: 22px;
      }
      div {
        display: inline-block;
        width: 80%;
        margin-left: 20px;
        input {
          width: 100%;
          background-color: #eef2f5;
          font-size: 16px;
        }
      }
    }
    .option {
      font-size: 14px;
      .left {
        float: left;
        cursor: pointer;
        padding-top: 10px;
        span {
          display: inline-block;
          vertical-align: middle;
          margin-right: 5px;
          width: 30px;
          height: 30px;
          background: url('../assets/icons/checkBox.png') no-repeat;
        }
      }
      a {
        float: right;
        margin-top: 5px;
      }
    }
    .login-button {
      margin-top: 20px;
      width: 342px;
      height: 48px;
      background: url('../assets/images/login.png') no-repeat;
      cursor: pointer;
      font-size: 22px;
      color: #fff;
    }
    .login-me {
      margin-top: 75px;
      bottom: 25px;
      width: 100%;
      line-height: 32px;
      .btn-Group {
        display: inline-block;
        .weChat {
          margin-left: 15px;
        }
      }
      a {
        float: right;
      }
    }
  }
}
.sx {
  width: 200px;
  height: 50px;
  font-size: 18px;
  color: #fff;
  background-color: #a77c5a ;
}
</style>
